import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';
import { SentryException } from './app/interceptors/custom-error-handlor';
import { appConfig } from './app/app.config';
import { installChunkErrorHandlers, tagChunkLoadEvent } from './app/services/chunk-reload';
import { readRunningBuild } from './app/services/app-update.service';

// Set by the deploy (index.html app-version meta); absent in local builds.
const build = readRunningBuild();

if (environment.production) {
  enableProdMode();
}

// Before Sentry.init, so these run ahead of Sentry's global handlers (MP-5600).
installChunkErrorHandlers();

Sentry.init({
  dsn: environment.sentryDsn,
  // Chunk-load errors are no longer ignored (MP-5600): they are reported with
  // chunk_load_error / chunk_recovery tags by services/chunk-reload.ts.
  ignoreErrors: [
    'node-fetch',
    // Browser noise with no buyer impact: skipped/aborted view transitions,
    // Facebook/Instagram in-app browsers, a browser extension.
    /view transition|Transition was (aborted|skipped)|ViewTransition/i,
    /Java object is gone/,
    /_META\.IABInnerFrame/,
    'Invalid call to runtime.sendMessage()'
  ],
  environment: environment.production ? 'superb-production' : 'superb-dev',
  release: build ? `embed@${build.version}` : undefined,
  initialScope: { tags: { app: 'embed', build_sha: build?.sha || 'unknown' } },
  integrations: [
    Sentry.replayIntegration({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true
    })
  ],
  tracePropagationTargets: [
    environment.projectsUrl,
    environment.apiBaseAddress
  ],
  beforeSend(event, hint) {
    if (event && event.logger === 'node-fetch') return null;
    const sentryException = new SentryException();
    if (sentryException.filterSentryException(event)) return null;
    return tagChunkLoadEvent(event, hint?.originalException);
  },
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0
});

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
